import type { MessageDescriptor } from 'react-intl';
import { isSignInMethodErrorCode } from 'fym-shared/src/music24/signInMethods';
import { signInMethodsMessages } from './signInMethodsMessages';

/** A client-side failure of a connect attempt: the popup closed, or the provider script is absent. */
export type ClientLinkFailure = 'cancelled' | 'unavailable';

/**
 * The message for a failed connect or disconnect. The API puts the code in `error.data.errorType`
 * (music24-api `signInMethodErrors.ts`). Every other failure is the generic message.
 */
export function signInMethodErrorMessage(error: unknown): MessageDescriptor {
  if (error === 'cancelled') {
    return signInMethodsMessages.errorCancelled;
  }
  if (error === 'unavailable') {
    return signInMethodsMessages.errorUnavailable;
  }
  const data =
    typeof error === 'object' && error !== null ? (error as { data?: { errorType?: unknown } | null }).data : undefined;
  const errorType = data?.errorType;
  if (!isSignInMethodErrorCode(errorType)) {
    return signInMethodsMessages.errorGeneric;
  }
  switch (errorType) {
    case 'M24_SIGNIN_IDENTITY_TAKEN':
      return signInMethodsMessages.errorIdentityTaken;
    case 'M24_SIGNIN_PROVIDER_ALREADY_CONNECTED':
      return signInMethodsMessages.errorProviderConnected;
    case 'M24_SIGNIN_LINK_STATE_INVALID':
      return signInMethodsMessages.errorState;
    case 'M24_SIGNIN_PROOF_INVALID':
      return signInMethodsMessages.errorProof;
    case 'M24_SIGNIN_PROVIDER_NOT_CONFIGURED':
      return signInMethodsMessages.errorUnavailable;
    case 'M24_SIGNIN_LAST_METHOD':
      return signInMethodsMessages.errorLastMethod;
    case 'M24_SIGNIN_METHOD_NOT_FOUND':
      return signInMethodsMessages.errorGeneric;
  }
}
